import { render, staticRenderFns } from "./descargarNota.vue?vue&type=template&id=418c4010&"
import script from "./descargarNota.vue?vue&type=script&lang=js&"
export * from "./descargarNota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports